import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class IntegracaoMonitoramentoKeys extends MainKeys {
    get place() {
        return Places.integracaoMonitoramento
    }
}

export default IntegracaoMonitoramentoKeys